import './UserMenu.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';  

interface UserMenuProps {
    handleLogout: any;
}

const UserMenu: React.FC<UserMenuProps> = ({handleLogout}) => {

    // ユーザー名
    const userName = useSelector((state: RootState) => state.user.userInfo?.user_name  ?? "");
    const userType = useSelector((state: RootState) => state.user.userInfo?.user_type);

    return (
        <div className="user-menu-container user-menu">
            <div className="user_icon_item">
                <img src={
                    userType === "external" ? "images/operator.svg" : "images/team.svg" 
                }
                className="user-image" alt="team" />
            </div>
            <div className="user_item">
                {userName}
            </div>
            <div className="logout_icon_item">
                <img src="images/logout.svg" className="logout-image" alt="team" />
            </div>
            <div className="logout_item" >
                <div onClick={handleLogout} className='logout'>
                    ログアウト
                </div>
            </div>
        </div>
    )
}

export default UserMenu;
